<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="account-definitions"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="itemsQuantity"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable">
					{{ props.row.code }}
				</td>
				<td>
					{{ props.row.name }}
				</td>
				<td>
					{{ props.row.moduleName }}
				</td>
				<td>
					<app-tooltip-button
						img="/static/img/actions-list/accounting-periods.svg"
						text="Reglas Ats"
						color="success"
						:width="40"
						@click-icon="$emit('click-icon', { action: 'rules', row: props.row })"
					/>
					<app-tooltip-button
						color="success"
						img="/static/img/actions-list/edit.svg"
						text="Editar"
						:width="25"
						@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
					/>
					<app-tooltip-button
						color="error"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar"
						:width="25"
						@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
					/>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', value: 'code', checked: true, visible: true },
			{ id: 2, name: 'Definición', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Módulo', value: 'name', checked: true, visible: true },
			{ id: 6, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
	};
}

export default {
	name: 'account-definitions-list',
	components: {
		appTooltipButton,
	},
	data,
	props: {
		currentPage: {
			default: 1,
			type: Number,
		},
		lastPage: {
			type: Number,
			default: 1,
		},
		itemsTotalQuantity: {
			type: Number,
			default: 1,
		},
		itemsQuantity: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/definitions-ats/definitions-list-ats.vue